import { render, staticRenderFns } from "./ServicosModal.vue?vue&type=template&id=4e9cc72f&scoped=true"
import script from "./ServicosModal.vue?vue&type=script&lang=js"
export * from "./ServicosModal.vue?vue&type=script&lang=js"
import style0 from "./ServicosModal.vue?vue&type=style&index=0&id=4e9cc72f&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9cc72f",
  null
  
)

export default component.exports